export default __webpack_public_path__ + "static/media/1078.3680ffe4.png";